import { RefObject, useEffect } from 'react';
import { ScheduleComponent } from '@syncfusion/ej2-react-schedule';
import dayjs from 'dayjs';
import { getConfig, setConfig } from '../../../utility_objects/WhiteCache';

/**
 * Gestisce la persistenza e lo scroll iniziale del calendario Studio:
 * - Override di getPersistData per salvare solo la scroll position (non eventSettings)
 * - Scroll all'ora corrente solo al primo caricamento del calendario
 */
export function useSchedulerPersistence(
  scheduleObj: RefObject<ScheduleComponent | null>,
  selectedDate: Date,
  focus10: boolean
) {
  // Override getPersistData: salva solo scroll position
  useEffect(() => {
    if (scheduleObj.current) {
      try {
        const schedule = scheduleObj.current as any; // eslint-disable-line @typescript-eslint/no-explicit-any
        const originalGetPersistData = schedule.getPersistData.bind(schedule);

        schedule.getPersistData = () => {
          let data = { scrollTop: 0, scrollLeft: 0 };
          try {
            const persistData = originalGetPersistData();
            data = JSON.parse(persistData);
          } catch (error) {
            console.error('Error in getPersistData override:', error);
          }
          return JSON.stringify({
            scrollTop: data.scrollTop ?? 0,
            scrollLeft: data.scrollLeft ?? 0,
          });
        };
      } catch (error) {
        console.error('Error overriding getPersistData:', error);
      }
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Scroll all'ora corrente solo al primo caricamento
  useEffect(() => {
    const config = getConfig();
    if (config.hasInitialScrolled.studio) return;

    const { underline } = config;
    if (
      scheduleObj?.current &&
      dayjs().isSame(dayjs(selectedDate), 'day') &&
      underline === '' &&
      !focus10
    ) {
      try {
        setTimeout(() => {
          scheduleObj?.current?.scrollTo(
            dayjs().subtract(1, 'hour').minute(0).format('HH:mm')
          );
          setConfig('hasInitialScrolled', {
            ...config.hasInitialScrolled,
            studio: true,
          });
        }, 200);
      } catch (error) {
        /* empty */
      }
    }
  }, [focus10, scheduleObj, selectedDate]);
}
